const setSelectedLanguage = ({ commit }, language) =>
  new Promise(resolve => {
    commit("SET_SELECTED_LANGUAGE", language);
    resolve();
  });

export default {
  setSelectedLanguage
};
